import React, { Component }  from 'react'

import './Success.css'
class Success extends Component {

  constructor(props) {
    super(props)
    this.state = {
       ok:''
    }
  
  }

  componentDidMount() {}

  render() {

    const titre=this.props.titre
    const message=this.props.message
    const boutton=this.props.boutton
    const handleValidate = this.props.handleValidate

    return (
      <>
        {/* <div className="c-app c-default-layout flex-row align-items-center"> */}
          {/* <div id='card' class="animated fadeIn"> */}
            <div id='upper-side'>
            
                <h3 id='stat'>
                   {titre}
                </h3>
            </div>
            <div id='lower-side'>
              <p id='message'>
                {message}
              </p>
              <a onClick={handleValidate} id="contBtn">{boutton}</a>
            </div>
          {/* </div> */}
        {/* </div> */}
      </>
    )
  }
}
export default Success
